import React from 'react';
import classes from "./CustomRadioGroup.module.css";

const CustomRadioGroup = ({ children, selectedValue, onChange, className, ...restProps }) => {
  return (
    <div className={classes["custom-radio-group"] + ' ' + className}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { selectedValue, onChange, ...restProps })
      )}
    </div>
  );
};

export default CustomRadioGroup;
